import SparklesIcon from "../../shared/SparklesIcon";
import { IStringLocalizer } from '../../../utilities/IStringLocalizer';
import { useLocalizer } from './hooks/useLocalizer';

interface AIHeaderProps {
    localizer?: IStringLocalizer;
}

export const AIHeader: React.FC<AIHeaderProps> = ({ localizer }) => {
    const localize = useLocalizer(localizer);

    return (
        <div className="ai-main-header">
            <div className="ai-icon-container">
                <SparklesIcon width={24} height={24} className="ai-icon" />
                <div className="ai-icon-glow"></div>
            </div>
            <h3 className="ai-title">{localize("Auto-answer with AI")}</h3>
        </div>
    );
}
